import { defineStyleConfig, StyleThemingProps } from '@chakra-ui/styled-system'
import { useStyleConfig } from '@chakra-ui/system'
import { getName } from '~/utils/objectUtils'

import { contactsColorKeys } from './_colors'

const ContactDetailViewColors = contactsColorKeys.Contacts.ContactsDetailView

export const ContactsDetailViewStyle = defineStyleConfig({
  baseStyle: {
    flexDirection: { base: 'column', md: 'row' },
    flex: '1 0 0',
    height: { base: 'fit-content', md: '50%' },
    padding: { base: '0.5rem', lg: '1.25rem', xl: '2.5rem' },
    gap: { base: '0.5rem', lg: '1.25rem', xl: '2.5rem' },
    borderTop: '2px solid',
    borderColor: ContactDetailViewColors.OuterContainer.BorderColor,
    overflowY: { base: 'scroll', md: 'visible' },
  },
})

export const useContactsDetailViewStyle = (props?: StyleThemingProps) => {
  return useStyleConfig(getName({ ContactsDetailViewStyle }), props)
}
